(function () {
  'use strict';

  var INDIC_RE = /[\u0660-\u0669\u06F0-\u06F9]/;
  var INDIC_REPLACE_RE = /[\u0660-\u0669\u06F0-\u06F9]/g;
  var DIGIT_RUN_RE = /(\+[\d][\d\s.\-/]*|\d[\d\s.\-/]*\d|\d+)/g;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1, PRE: 1, SVG: 1, OPTION: 1 };

  function isRtl() {
    return document.documentElement.getAttribute('dir') === 'rtl';
  }

  function toLatinDigits(str) {
    return str.replace(INDIC_REPLACE_RE, function (ch) {
      var code = ch.charCodeAt(0);
      if (code >= 0x0660 && code <= 0x0669) return String(code - 0x0660);
      if (code >= 0x06f0 && code <= 0x06f9) return String(code - 0x06f0);
      return ch;
    });
  }

  var CURRENCY_BHD_RE = /\bBHD\b/g;
  var CURRENCY_BD_RE = /\bBD\b/g;
  var PRICE_EXTRA_DECIMAL_RE = /(\d+\.\d{2})0(\s*(?:BD|BHD|د\.ب))/g;

  function stripExtraDecimal(str) {
    return str.replace(PRICE_EXTRA_DECIMAL_RE, '$1$2');
  }

  function localizeCurrency(str) {
    if (!isRtl()) return str;
    return str.replace(CURRENCY_BHD_RE, 'د.ب').replace(CURRENCY_BD_RE, 'د.ب');
  }

  // The currency-converter app owns .glc-money: it parses the literal
  // "30.800 BHD" inside and swaps in the visitor's currency. Rewriting BHD to
  // د.ب here left it nothing to match, which is exactly why conversion worked
  // in English but never in Arabic. Money spans are handled separately below.
  var MONEY_SEL = '.glc-money';

  function shouldSkipNode(node) {
    var parent = node.parentElement;
    if (parent && parent.closest && parent.closest(MONEY_SEL)) return true;
    while (parent) {
      if (SKIP_TAGS[parent.tagName]) return true;
      if (parent.hasAttribute('data-latin-digits')) return true;
      if (parent.closest && parent.closest('[data-no-latin-digits]')) return true;
      parent = parent.parentElement;
    }
    return false;
  }

  function wrapDigitRuns(text) {
    var parts = [];
    var last = 0;
    var match;

    DIGIT_RUN_RE.lastIndex = 0;
    while ((match = DIGIT_RUN_RE.exec(text)) !== null) {
      if (match.index > last) parts.push({ type: 'text', value: text.slice(last, match.index) });
      parts.push({ type: 'digits', value: match[0] });
      last = DIGIT_RUN_RE.lastIndex;
    }

    if (!parts.length) return null;
    if (last < text.length) parts.push({ type: 'text', value: text.slice(last) });
    return parts;
  }

  function processTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE || shouldSkipNode(node)) return;

    var original = node.nodeValue;
    if (!original || !original.trim()) return;

    var text = localizeCurrency(stripExtraDecimal(toLatinDigits(original)));
    var parent = node.parentElement;
    if (!parent) return;

    if (isRtl() && /\d/.test(text)) {
      var parts = wrapDigitRuns(text);
      if (parts && parts.some(function (p) { return p.type === 'digits'; })) {
        var frag = document.createDocumentFragment();
        parts.forEach(function (part) {
          if (part.type === 'digits') {
            var span = document.createElement('span');
            span.className = 'lp-latin-digits';
            span.setAttribute('data-latin-digits', '');
            span.textContent = part.value;
            frag.appendChild(span);
          } else if (part.value) {
            frag.appendChild(document.createTextNode(part.value));
          }
        });
        parent.replaceChild(frag, node);
        return;
      }
    }

    if (text !== original) node.nodeValue = text;
  }

  function walk(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var batch = [];
    var n;
    while ((n = walker.nextNode())) batch.push(n);
    batch.forEach(processTextNode);
  }

  var timer;
  function scheduleWalk() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      walk(document.body);
    }, 50);
  }

  // On the Bahrain market the app leaves prices in BHD, so we may safely show
  // the Arabic label. On every other market a conversion is expected, so the
  // text is left alone for the app to rewrite.
  function isHomeMarket() {
    var c = (window.Shopify && window.Shopify.country) || '';
    return !c || c === 'BH';
  }

  // Arabic-Indic separators the converter app can emit when it formats with an
  // ar locale. Digits are handled by toLatinDigits.
  var AR_DECIMAL_RE = /\u066B/g;   // ٫
  var AR_THOUSANDS_RE = /\u066C/g; // ٬

  function forceLatinNumerals(str) {
    return toLatinDigits(str).replace(AR_DECIMAL_RE, '.').replace(AR_THOUSANDS_RE, ',');
  }

  function localizeMoneyLabels() {
    if (!isRtl()) return;
    var home = isHomeMarket();
    document.querySelectorAll(MONEY_SEL).forEach(function (el) {
      var txt = el.textContent;
      var next = forceLatinNumerals(txt);
      // The Arabic currency label is only safe on the home market; elsewhere the
      // app needs the literal BHD to find and convert. Digits are always forced
      // to Latin — that never removes the token the app matches on.
      if (home && /\b(BHD|BD)\b/.test(next)) {
        next = localizeCurrency(stripExtraDecimal(next));
      }
      if (next !== txt) el.textContent = next;
    });
  }

  function init() {
    walk(document.body);
    // give the currency app time to claim the money spans first
    localizeMoneyLabels();
    setTimeout(localizeMoneyLabels, 400);
    setTimeout(localizeMoneyLabels, 1200);
    setTimeout(localizeMoneyLabels, 3000);

    new MutationObserver(function (mutations) {
      var needsFull = false;
      mutations.forEach(function (m) {
        if (m.type === 'characterData') {
          processTextNode(m.target);
        } else if (m.addedNodes && m.addedNodes.length) {
          needsFull = true;
        }
      });
      if (needsFull) { scheduleWalk(); setTimeout(localizeMoneyLabels, 400); }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('shopify:section:load', scheduleWalk);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* Hide count bubbles when the count is 0 (cart, wishlist, compare — header + mobile toolbar) */
(function lpHideZeroCounts() {
  var SEL = 'hdt-cart-count, hdt-wishlist-count, hdt-compare-count, .hdt-count-box, .hdt-toolbar__count-box';
  var seen = new WeakSet();
  function upd(el) {
    el.style.display = el.textContent.trim() === '0' ? 'none' : '';
  }
  function scan() {
    document.querySelectorAll(SEL).forEach(function (el) {
      upd(el);
      if (seen.has(el)) return;
      seen.add(el);
      new MutationObserver(function () { upd(el); }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();


/* Shopify Inbox: localize the custom "Need help?" button label on Arabic pages
   (custom labels are not auto-translated by Shopify). */
(function lpInboxArabic() {
  var lang = (document.documentElement.lang || '').toLowerCase();
  if (lang.indexOf('ar') !== 0) return;
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var n, done = false;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.trim() === 'Need help?') {
        n.nodeValue = n.nodeValue.replace('Need help?', 'هل تحتاج مساعدة؟');
        done = true;
      }
    }
    if (done || tries > 20) clearInterval(timer);
  }, 1000);
})();
